import { Component, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'cp-compliance-expired-notification',
  templateUrl: './compliance-expired-notification.component.html',
  styleUrls: ['./compliance-expired-notification.component.scss'],
  encapsulation: ViewEncapsulation.Emulated,
})
export class ComplianceExpiredNotificationComponent {
  constructor(private _router: Router) {}

  public get isNotCompliancePage(): boolean {
    return !this._router.url.startsWith('/compliance');
  }
}
